<script lang="ts" setup>
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { createPopup } from '@typeform/embed'
import '@typeform/embed/build/css/popup.css'

const isXs = computed(() => {
  const { xs } = useDisplay()
  return xs.value
})

const { toggle } = createPopup('GbMxAg0K', {
  height: isXs.value ? 300 : 600,
  width: 100
})
defineExpose({
  toggle
})
</script>
<style scoped></style>
<style>
.tf-v1-popup {
  align-items: end !important;
  justify-content: end !important;
  padding-bottom: 5rem;
  padding-right: 5rem;
  background: none;
}
.tf-v1-popup .tf-v1-close {
  margin-top: 15%;
  margin-right: 5%;
}
@media (max-width: 375px) {
  .tf-v1-popup {
    padding-bottom: 2rem;
    padding-right: 2rem;
  }
}
.tf-v1-popup .tf-v1-close {
  color: black !important;
}
.tf-v1-iframe-wrapper {
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
</style>
